import { __extends } from "tslib";
import { RenderHtml } from '../../../utils';
import * as React from 'react';
import { HeightAnimation, OpacityAnimation, KeyCode } from '@wix/answers-ui-libby';
export var CollapsibleToggleAnimation = function (props) { return (React.createElement(HeightAnimation, { show: props.show },
    React.createElement(OpacityAnimation, { show: props.show }, props.children))); };
var CollapsibleComponent = /** @class */ (function (_super) {
    __extends(CollapsibleComponent, _super);
    function CollapsibleComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.componentDidMount = function () {
            document.addEventListener('keydown', _this.openOnKeyboardSearch);
            _this.setInnerTabIndex();
        };
        _this.setInnerTabIndex = function () {
            var tabIndex = _this.state.isOpen ? '0' : '-1';
            if (_this.collapsRef) {
                Array.from(_this.collapsRef.querySelectorAll('a')).forEach(function (elem) { return elem.setAttribute('tabIndex', tabIndex); });
            }
        };
        _this.componentWillUnmount = function () {
            if (_this.collapsRef) {
                _this.collapsRef.removeEventListener('keyup', _this.onAccessibilityKeyup);
                _this.collapsRef.removeEventListener('click', _this.onAccessibilityClick);
            }
            document.removeEventListener('keydown', _this.openOnKeyboardSearch);
        };
        _this.openOnKeyboardSearch = function (e) {
            if ((e.ctrlKey || e.metaKey) && e.keyCode === KeyCode.F) {
                _this.setState({ isOpen: true });
            }
        };
        _this.toggleCollapsible = function () {
            var isOpen = !_this.state.isOpen;
            _this.setState({ isOpen: isOpen });
            _this.setInnerTabIndex();
        };
        _this.onAccessibilityKeyup = function (e) {
            if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                _this.toggleCollapsible();
            }
        };
        _this.onAccessibilityClick = function () {
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };
        _this.setCollapsRef = function (elem) {
            if (elem) {
                _this.collapsRef = elem;
                elem.addEventListener('keyup', _this.onAccessibilityKeyup);
                elem.addEventListener('click', _this.onAccessibilityClick);
            }
        };
        return _this;
    }
    CollapsibleComponent.prototype.render = function () {
        var props = this.props;
        var bodyClassName = "collapsible-body " + (this.state.isOpen ? 'open' : '');
        return (React.createElement("div", { className: 'component collapsible-component', "data-component-type": 'collapsible' },
            React.createElement("div", { className: bodyClassName },
                React.createElement("div", { tabIndex: 0, ref: this.setCollapsRef, className: 'collapsible-wrapper' },
                    React.createElement("div", { role: 'button', "aria-expanded": this.state.isOpen, className: 'collapsible-heading', onClick: this.toggleCollapsible },
                        React.createElement("div", { className: 'title' }, props.value.title)),
                    React.createElement("div", { "aria-hidden": !this.state.isOpen, className: 'collapsible-content' },
                        React.createElement(CollapsibleToggleAnimation, { show: this.state.isOpen },
                            React.createElement(RenderHtml, { html: props.value.html, className: 'rendered-html' })))))));
    };
    return CollapsibleComponent;
}(React.Component));
export { CollapsibleComponent };
//# sourceMappingURL=collapsible-component.comp.js.map